// Metadados visuais dos 4 temas de pesquisa — usados em badges, filtros e gráficos.
export const THEMES = [
  { value: 'saúde_emocional', label: 'Saúde emocional', dot: 'bg-rose-500', badge: 'bg-rose-50 text-rose-700 ring-rose-600/10' },
  { value: 'linguagem_gírias', label: 'Linguagem & gírias', dot: 'bg-sky-500', badge: 'bg-sky-50 text-sky-700 ring-sky-600/10' },
  { value: 'moda_tendências', label: 'Moda & tendências', dot: 'bg-fuchsia-500', badge: 'bg-fuchsia-50 text-fuchsia-700 ring-fuchsia-600/10' },
  { value: 'viés_político', label: 'Viés político', dot: 'bg-violet-500', badge: 'bg-violet-50 text-violet-700 ring-violet-600/10' },
];

export function themeMeta(value) {
  return THEMES.find((t) => t.value === value) || { label: value || 'Sem tema', dot: 'bg-slate-400', badge: 'bg-slate-100 text-slate-600 ring-slate-500/10' };
}

// Cores em hex (recharts/mapa não entendem classes Tailwind) — mesmas cores dos badges.
export const THEME_HEX = {
  'saúde_emocional': '#f43f5e',
  'linguagem_gírias': '#0ea5e9',
  'moda_tendências': '#d946ef',
  'viés_político': '#8b5cf6',
  null: '#94a3b8',
};

export function themeLabel(value) {
  return themeMeta(value).label;
}

// Localidade (MVP, pelo idioma de busca) -> países representativos destacados no mapa.
// Aproximado: fica mais preciso quando a IA extrair o país real de cada notícia (fase futura).
export const LOCALITY_COUNTRIES = {
  Brasil: ['Brazil'],
  'América Latina': ['Mexico', 'Argentina', 'Colombia', 'Chile', 'Peru', 'Venezuela', 'Ecuador'],
  Internacional: ['United States of America', 'United Kingdom', 'Canada'],
  // Localidades dos portais diretos (backend/src/services/feed_sources.py).
  'América do Norte': ['United States of America', 'Canada'],
  Europa: ['United Kingdom', 'Portugal', 'Spain', 'France', 'Germany', 'Italy', 'Russia'],
  'Ásia': ['China', 'Japan', 'South Korea', 'India'],
  'Oriente Médio': ['Israel', 'Qatar'],
  'África': ['South Africa', 'Nigeria', 'Egypt', 'Kenya'],
  Oceania: ['Australia', 'New Zealand'],
};

export function formatDate(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return value;
  }
}

export function formatDateTime(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('pt-BR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch {
    return value;
  }
}

export const PLATFORM_LABEL = {
  instagram: 'Instagram',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  desconhecida: 'Desconhecida',
};

export const LEAD_STATUS_LABEL = {
  novo: 'Novo',
  investigando: 'Investigando',
  promovido: 'Promovido',
  descartado: 'Descartado',
};

export const LEAD_STATUS_BADGE = {
  novo: 'bg-amber-50 text-amber-700 ring-amber-600/10',
  investigando: 'bg-sky-50 text-sky-700 ring-sky-600/10',
  promovido: 'bg-emerald-50 text-emerald-700 ring-emerald-600/10',
  descartado: 'bg-slate-100 text-slate-500 ring-slate-500/10',
};

// Farol de valores do influenciador (0 verde → 3 vermelho; null = sem dados suficientes).
export const RISK_LEVELS = {
  0: { label: 'Positivo', dot: 'bg-emerald-500', badge: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20' },
  1: { label: 'Atenção', dot: 'bg-amber-400', badge: 'bg-amber-50 text-amber-700 ring-amber-600/20' },
  2: { label: 'Preocupante', dot: 'bg-pink-500', badge: 'bg-pink-50 text-pink-700 ring-pink-600/20' },
  3: { label: 'Nocivo', dot: 'bg-red-600', badge: 'bg-red-50 text-red-700 ring-red-600/20' },
};
export const RISK_UNKNOWN = { label: 'Sem dados', dot: 'bg-slate-300', badge: 'bg-slate-50 text-slate-500 ring-slate-400/20' };
